// src/sections/Testimonials/testimonialData.ts
import ShaileshBhargava from "../../assets/img/client/testimonial-5.jpg";
import AmolBhinge from "../../assets/img/client/AmolBhinge.png";
import PS_Circle_Headshot from "../../assets/img/client/PS_Circle_Headshot.png";
import coral from "../../assets/img/client/coral.jpg"; // Assuming this is the correct path for Coral's image
export interface Testimonial {
  rating: number;
  id: number;
  name: string;
  title: string;
  content: string;
  avatarSrc: string; // URL or path to image
  initials?: string; // Optional: used if avatarSrc is empty
}

export const testimonialsData: Testimonial[] = [
  {
    id: 1,
    name: "Priscilla Soriano",
    title: "Founder - Unica Digital",
    content: `I have had the pleasure of knowing and working with Elenoit. Elenoit's expertise, proactiveness and professionalism was crucial in establishing and growing my company, Unica Digital. They are excellent communicator and works diligently and quickly to complete projects and tasks. It has a wide range of experience in paid search across many verticals. Elenoit mastery of ecommerce and performance-based campaigns makes it a valuable asset to any team working towards defined objectives via digital marketing strategies. Overall, Elenoit is a very talented professional that I would highly recommend.`,
    avatarSrc: PS_Circle_Headshot,
    rating: 5,
  },
  {
    id: 2,
    name: "Coral",
    title: "Head of Acquisition",
    content: `I worked with Elenoit on multiple client projects within paid media since 2018. It was very easy to work with Elenoit and all team members went above and beyond what was expected. Elenoit's extensive knowledge of both Google and Bing significantly improved performance after performance had been suffering for some time. It was very well organized in how it set up campaigns in addition to providing clear communication during each step from planning to implementation to recaps. I trust Elenoit expertise in best practices and I can rely on Elenoit to get the job done, as Elenoit has done complex audits in a short time frame. I would definitely recommend working with Elenoit.`,
    avatarSrc: coral,
    rating: 5,
  },
  {
    id: 3,
    name: "Shailesh Bhargava",
    title: "Co- Founder & VP (IT),True Vision",
    content: `I would like to express our gratitude on behalf of the True Vision management team for the outstanding work you made on the project. Your professionalism shines through in the endless hours you put into the project to ensure a successful completion. This has wowed the entire group.We look up to you because of your self-motivation, dedication, and hard work.`,
    avatarSrc: ShaileshBhargava,
    rating: 5,
  },
  {
    id: 4,
    name: "Amol Bhinge",
    title: "Founder & Chief Volunteer, ToiletSeva",
    content: `Elenoit has demonstrated passionate work ethics while working at ToiletSeva assignment.Elenoit has delivered an important pillar, the admin dashboard, for ToiletSeva.All team members are hard-working with a committed attitude.Elenoit is approachable, easy to work with and brings a humble approach to the table. We look forward to continuing collaborating with Elenoit and we wish Elenoit the very best.`,
    avatarSrc: AmolBhinge,
    rating: 5,
  },
  {
    id: 5,
    name: "Kerau Nameho",
    title: "Founder Member, Vice President IT Operations Solve Right LLC",
    content: `parikshit is working with our organization since 10/26/2020, on an hourly basis. During all assignments, Parikshit proved himself to be dependable and a hard worker with solid problem solving and technical skills. I am always impressed by Parikshit's ability to complete the work assigned on time. Although Parikshit is a fast learner, it is very careful and cautious to perform complex tasks first time around, which prevents us getting into a feedback loop. It also helps our organization not to make costly mistakes. Overall, Parikshit is a talented individual whom we would Continue to work with.`,
    avatarSrc: "", // No image, will use initials
    initials: "KN",
    rating: 5,
  },
];
